import React, { useState, useRef, useContext } from "react";
import { FaBackward, FaSpinner, FaCheckCircle } from "react-icons/fa";
import "./allaccountsteps.scss";
import { Link } from "react-router-dom";
import AgreementModal from "../modals/AgreementModal";
import MultiStepFormContext from "./../MultiStepForm/MultiStepFormContext";

import { downloadFileFromResponse, showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import {
  agreementTexts,
  buttonName,
  commonErrMsg,
  commonValidationMsg,
  onboardingStepData,
  pagination,
  tooltips,
  uploadDoc
} from "../../locales/en";
import { FILE_SIZE_LIMIT } from "../../utils/constants/appConstants";
import privateAxios from "../../utils/axiosPrivate";
import {
  getAgreementDownloadUrl,
  getAgreementUploadUrl,
  getAgreementUploadUrlLaterStatusUrl,
  getGenerateEmailUrl
} from "../../utils/constants/apiEndPoints";

const Agreement = () => {
  const {
    next,
    prev,
    isConnectedSoftware,
    annatureStatusData,
    handleAnnatureCheckStatus
  } = useContext(MultiStepFormContext);
  const [showManually, setShowManually] = useState();
  const [addAgreementModal, setAddAgreementModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [isUploadLater, setIsUploadLater] = useState(false);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const fileInput = useRef(null);

  const [anatureDataUrl, setAnatureDataUrl] = useState(null);
  const [anatureLoading, setAnatureLoading] = useState(false);
  const [anatureError, setAnatureError] = useState(null);

  const handleOpenAnaturePdf = async () => {
    try {
      setAnatureLoading(true);
      const response = await privateAxios.post(getGenerateEmailUrl);
      setAnatureDataUrl(response.data.data.signingToken);
    } catch {
      setAnatureError(commonErrMsg?.failedDocumentCreate);
    } finally {
      setAnatureLoading(false);
    }
  };

  // Aggrement Download Function
  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await privateAxios.get(getAgreementDownloadUrl, {
        responseType: "arraybuffer"
      });
      downloadFileFromResponse(response);
    } catch {
      showToast(commonErrMsg?.item11, showToastType.error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (event) => {
    const { files } = event.target;

    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];

    if (file.size > FILE_SIZE_LIMIT) {
      showToast(commonValidationMsg?.fileLimitError, showToastType.error);
      event.target.value = "";
      setFileName("");
      return;
    }

    setFileName(file.name);

    try {
      setLoadingUpload(true);

      const formDataToSend = new FormData();
      formDataToSend.append("file", file, file.name);

      const config = {
        method: "post",
        url: getAgreementUploadUrl,
        headers: { "Content-Type": "multipart/form-data" },
        data: formDataToSend
      };

      const response = await privateAxios(config);

      if (response.status === 201) {
        showToast(response.data.message, showToastType.success);
      }
    } catch (error) {
      if (error.response) {
        showToast(error.response.data.message, showToastType.error);
      }
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleUploadButtonClick = () => {
    fileInput.current.click();
  };

  const handleCheckboxChange = async (e) => {
    const { checked, type, value } = e.target;

    const newValue = type === "checkbox" ? checked : value;

    setIsUploadLater(newValue);
    if (!checked) return;
    try {
      const response = await privateAxios.post(
        getAgreementUploadUrlLaterStatusUrl,
        {},
        {
          params: {
            isUploadLater: newValue
          }
        }
      );

      if (response.status === 200) {
        showToast(response.data.message, showToastType.success);
      }
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    }
  };

  const handleSubmit = () => {
    next();
  };

  const toggleShowManually = () => {
    setShowManually(!showManually);
  };

  const handleBackToDigitalClick = () => {
    setShowManually(false);
  };

  const showAgreementModal = () => {
    if (!addAgreementModal) {
      handleOpenAnaturePdf();
    }
    setAddAgreementModal(!addAgreementModal);
  };

  const agreementProps = {
    isOpen: addAgreementModal,
    toggle: showAgreementModal,
    handleAnnatureCheckStatus,
    setIsDisabledButton,
    anatureDataUrl,
    loading: anatureLoading,
    error: anatureError
  };

  return (
    <>
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="step-wrap">
            <div className="step-title">
              <h3>
                {isConnectedSoftware
                  ? agreementTexts?.step4text
                  : onboardingStepData?.withoutConnected?.step3}
              </h3>
            </div>
            <div className="step-content mt-3">
              <div
                className={`${showManually ? "hide" : "show"} hide-manually`}
              >
                <div className="aplyid-section">
                  {annatureStatusData && annatureStatusData.status ? (
                    <p className="text-success">
                      <FaCheckCircle /> {annatureStatusData?.displayText}
                    </p>
                  ) : (
                    <p>{uploadDoc?.note}</p>
                  )}
                </div>

                <div className="agreement-btn-group mb-3">
                  {!(annatureStatusData && annatureStatusData.status) && (
                    <>
                      <button
                        type="button"
                        className="btn-primary"
                        onClick={showAgreementModal}
                        disabled={isDisabledButton}
                      >
                        {agreementTexts?.reviewSign}
                      </button>
                      <button
                        type="button"
                        className="border-btn-primary mt-2"
                        onClick={toggleShowManually}
                        disabled={isDisabledButton}
                      >
                        {agreementTexts?.signUpload}
                      </button>
                    </>
                  )}
                </div>
              </div>
              {showManually && (
                <div className="show-manually-wrap mt-5">
                  <div className="show-manual-btn mb-5">
                    <button
                      type="button"
                      className="border-btn-primary"
                      onClick={handleBackToDigitalClick}
                    >
                      <FaBackward /> {agreementTexts?.reviewSign}
                    </button>
                  </div>
                  <div className="aplyid-section">
                    <p>{agreementTexts?.pleaseDownload}</p>
                    <p>{agreementTexts?.youComplete}</p>

                    <div className="agreement-group-warp mt-5">
                      <div className="row mb-2">
                        <div className="col-md-6 d-flex pt-2 pb-2 align-items-center">
                          <label htmlFor="Download">
                            {agreementTexts?.downloadAgreement}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <Link
                            className={`btn btn-primary fundtap_agreement spinDiv ${loading ? "spinDivBlack" : ""}`}
                            id="Download"
                            onClick={handleDownload}
                          >
                            {buttonName.download}
                            {loading && (
                              <span className="loadSpin">
                                <FaSpinner />
                              </span>
                            )}
                          </Link>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 d-flex pt-2 pb-2 align-items-center">
                          <label htmlFor="uploadAgreement">
                            {agreementTexts?.uploadAgreement}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <div className="upload-file">
                            {fileName && (
                              <p className="uploaded-file-name">{fileName}</p>
                            )}
                            <button
                              type="button"
                              onClick={handleUploadButtonClick}
                              className={`btn btn-primary fundtap_agreement spinDiv ${loadingUpload ? "spinDivBlack" : ""}`}
                            >
                              {tooltips.upload}
                              {loadingUpload && (
                                <span className="loadSpin">
                                  <FaSpinner />
                                </span>
                              )}
                            </button>
                            <input
                              name="isFile"
                              type="file"
                              ref={fileInput}
                              onChange={handleFileChange}
                              className="d-none"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 offset-md-6">
                          <div className="upload-checkbox">
                            <label htmlFor="upload">
                              {buttonName?.uploadLater}
                            </label>
                            <input
                              type="checkbox"
                              id="upload"
                              checked={isUploadLater}
                              value={isUploadLater}
                              onChange={handleCheckboxChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="step-btn-group d-flex justify-content-center align-items-center mt-5 mb-5">
        <div className="prev-btn p-1">
          <button type="button" className="btn btn-primary" onClick={prev}>
            {pagination.previous}
          </button>
        </div>
        <div className="next-btn p-1">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {pagination.next}
          </button>
        </div>
      </div>

      <AgreementModal {...agreementProps} />
    </>
  );
};

export default Agreement;
